import { includes } from 'lodash';

export class JwtInterceptor {
    constructor(API, apiTokenPromise, store) {
        this.axiosInstance = API.http;
        this.apiTokenPromise = apiTokenPromise;
        this.store = store;
        this.wrapperInstance = API;

        this.requestOnFulfilled = (config) => {
            if (config.url === 'v3/auth/token') return config;
            if (this.store.getters['jwt/getIsInRetryMode']) {
                return this.waitForAccessTokenAndRetryRequest(config);
            }
            this.setAuthorisationHeader(config);
            return config;
        };

        this.requestOnRejected = (error) => {
            throw error;
        };

        this.responseOnFulfilled = (response) => {
            if (response.headers['x-trimoz-api-version']) {
                this.wrapperInstance.apiVersion = response.headers['x-trimoz-api-version'];
            }
            if (response.headers['x-trimoz-api-version-date']) {
                this.wrapperInstance.apiVersionDate = response.headers['x-trimoz-api-version-date'];
            }
            if (response.headers['x-trimoz-sec-whitelisted']) {
                this.wrapperInstance.apiSecurityWhitelistingIp = response.headers['x-trimoz-sec-whitelisted'];
            }
            return response;
        };

        this.responseOnRejected = (error) => {
            this.ensureRouteShouldRefreshAccessTokenOrThrow(error);

            if (!this.store.getters['jwt/getIsInRetryMode']) {
                this.store.commit('jwt/SET_IS_IN_RETRY_MODE', true);
                this.apiTokenPromise()
                    .then(res => {
                        this.store.commit('jwt/SET_IS_IN_RETRY_MODE', false);
                        if (res.status !== 200) throw error;
                        this.store.commit('jwt/SET_ACCESS_TOKEN', res.data.accessToken);
                        this.onAccessTokenFetched(true);
                    })
                    .catch(() => {
                        this.store.commit('jwt/CLEAR_ACCESS_TOKEN');
                        this.store.commit('jwt/SET_IS_IN_RETRY_MODE', false);
                        this.onAccessTokenFetched(false);
                        throw error;
                    });
            }
            return this.waitForAccessTokenAndRetryRequest(error.config);
        };

        this.setAuthorisationHeader = (config) => {
            const token = this.store.getters['jwt/getAccessToken'];
            if (token) {
                if (!config.headers) {
                    config.headers = {};
                }
                config.auth = undefined;
                config.headers['Authorization'] = 'Bearer ' + token;
            }
        };

        this.waitForAccessTokenAndRetryRequest = (config) => {
            return new Promise((resolve, reject) => {
                this.store.commit('jwt/ENQUEUE_REQUEST', (tokenIsRefreshed) => {
                    if (tokenIsRefreshed) {
                        resolve(this.axiosInstance(config));
                    }
                    reject(new Error('Request has been canceled because refresh token call has failed'));
                });
            });
        };

        this.onAccessTokenFetched = (tokenIsRefreshed) => {
            this.store.commit('jwt/DEQUEUE_REQUEST');
            while(this.store.getters['jwt/getHeadRequest']) {
                const req = this.store.getters['jwt/getHeadRequest'];
                req(tokenIsRefreshed);
                this.store.commit('jwt/DEQUEUE_REQUEST');
            }
        };

        this.ensureRouteShouldRefreshAccessTokenOrThrow = (error) => {
            if (error.response && error.response.status !== 401) throw error;
            if (includes(error.config.url, 'v3/auth/login')) throw error;
            if (includes(error.config.url, 'v3/auth/token')) throw error;
            if (includes(error.config.url, 'v3/auth/mfa')) throw error;
            if (!includes(error.config.headers.Authorization, 'Bearer')) throw error;
        };
    }
}
